module.exports = __webpack_public_path__ + "static/media/lintBig.799ef8c5.JPG";